<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    left2Data: {
      type: Object,
      default: () => {},
    }
  },
  setup(props) {
    // console.log(props);
    const myEcharts = ref(null);
    const chart = new InitChart(props, myEcharts);
    onMounted(() => {
      // console.log(props)
      chart.init(props.left2Data,props.name,props.color);
      
    });
    return {
      myEcharts,
    };
  },
};
class InitChart {
  constructor(props, myEcharts) {
    this.props = props;
    this.myEcharts = myEcharts;
    this.state = {
      chart: null,
    };
  }

  init() {
    this.state.chart && this.destory();
    this.state.chart = echarts.init(this.myEcharts.value);

   let diff = [{ name: '纺织类', value: 10 ,unit:""}, 
    { name: '制鞋产业', value: 90 ,unit:"" }, 
    { name: '体育用品', value: 80 ,unit:"" }, 
    { name: '制鞋产业', value: 70  ,unit:""}, 
    { name: '制鞋产业', value: 60  ,unit:""}]

    this.state.chart.setOption({
         tooltip: {
            show: true,
            trigger: 'item',
            padding: [8, 15],
            backgroundColor: 'rgba(12, 51, 115,0.8)',
            borderColor: 'rgba(3, 11, 44, 0.5)',
            textStyle: {
                color: 'rgba(255, 255, 255, 1)',
                fontSize: 28,
            },
        },
        legend: {show: false,},
        grid: {left: '0%',right: '8%',top: '10%',bottom: '3%',},
        xAxis: [
            {
                splitLine: {show: false,},
                type: 'value',
                show: false,
                axisLine: {     //x轴坐标轴，false为隐藏，true为显示
                    show: false
                },
            },
        ],
        yAxis: [{
                show: true,
                splitLine: {show: false,},
                axisLine: { show: false,},
                type: 'category',
                axisTick: {show: false,},
                inverse: true,
                axisLabel: { show: false,},
            },{
                type: 'category',
                inverse: true,
                axisTick: 'none',
                axisLine: 'none',
                show: true,
                axisLabel: {
                    textStyle: {
                        color: '#fff',
                        fontSize: 30
                    },
                    formatter: function (value , index  ) {
                        return value + diff[index].unit ;
                    },
                },
                data: diff,
            },],
        series: [{
                show: true,
                name: '',
                type: 'bar',
                data: diff,
                barWidth: 20, // 柱子宽度
                showBackground: true,
                backgroundStyle: {
                  borderRadius: [20],
                },
                label: {
                    show: true,
                    width: 200,
                    offset: [0,-50,0,0],
                    color: 'rgba(255, 255, 255, 1)',
                    fontFamily: 'SourceHanSansCN-Normal',
                    fontSize: 30,
                    fontWeight: 500,
                    position: [10, 10],
                    formatter: function (params) {
                        return params.data.name;
                    }},
                itemStyle: {
                    show: true,
                    barBorderRadius: [20],
                    color: {
                        type: "linear",
                        colorStops: [{ offset: 1, color: "rgba(40, 209, 247, 1)", }, { offset: 0, color: "rgba(40, 209, 247, 0)", },],
                    },
                },
                emphasis: {disabled: true,}
            },
            {
                name: "",
                type: "scatter",
                emphasis: { scale: false},
                symbol: "circle",
                symbolSize: [20,20],// 进度条白点
                itemStyle: {
                    show: true,
                    barBorderRadius: [10, 10, 10, 10],
                    color: '#FFF',
                    shadowColor: "rgba(25, 136, 126, 1)",
                    shadowBlur: 10,
                    borderWidth: 2,
                    opacity: 1,
                },
                z: 2,
                data: diff,
                animationDelay: 500,
            },
            
        ],
    });
    window.addEventListener("resize", () => {
      this.state.chart.resize();
    });
  }

  destory() {
    this.state.chart.dispose();
    window.removeEventListener("resize", () => {
      console.log("事件移除");
    });
  }
}
</script>
<style lang="less"></style>
